import { render, staticRenderFns } from "./MyReserveList.vue?vue&type=template&id=ca3c73b8&scoped=true"
import script from "./MyReserveList.ts?vue&type=script&lang=ts&external"
export * from "./MyReserveList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3c73b8",
  null
  
)

export default component.exports